/* eslint-disable @typescript-eslint/naming-convention */
import { Settings } from 'react-slick';

// seat map section color
export const MAP_SECTION_COLOR = 'rgba(50,108,100)';

// next-iron-session cookie name
export const SESSION_COOKIE_NAME = '_crw';
// keys for session cookies
export enum SESSION_KEYS {
  USER = 'USER',
  TOKEN = 'TOKEN',
  FOLLOW = 'FOLLOW',
}

export enum NEXT_STEPS {
  hotel = 'hotel',
  flight = 'flight',
  tickets = 'tickets',
  checkout = 'checkout',
}

export enum AGE {
  CHILD = 11,
  INFANT = 1,
  ADULT = 12,
}

// analytics event types
export enum TrackedEvents {
  HOTEL_SELECTED = 'HOTEL_SELECTED',
  TICKET_SELECTED = 'TICKET_SELECTED',
  CREATE_ORDER = 'CREATE_ORDER',
  BUNDLE_TYPE = 'BUNDLE_TYPE',
  BYP_TICKET_SELECTED = 'BYP_TICKET_SELECTED',
  BYP_ROOM_SELECTED = 'BYP_ROOM_SELECTED',
  SIGN_IN_TYPE = 'SIGN_IN_TYPE',
  QUOTATION_SENT = 'QUOTATION_SENT',
  OFFER_SHARED_WITH_FRIENDS = 'OFFER_SHARED_WITH_FRIENDS',
  VIEW_CHECKOUT_PAGE = 'VIEW_CHECKOUT_PAGE',
  FLIGHTS_SEARCHED = 'FLIGHTS_SEARCHED',
  FLIGHTS_SELECTED_DEPARTURE = 'FLIGHTS_SELECTED_DEPARTURE',
  FLIGHTS_SELECTED_RETURN = 'FLIGHTS_SELECTED_RETURN',
  FLIGHTS_SELECTED_FARE = 'FLIGHTS_SELECTED_FARE',
}

// list of SorterOption for select
export const listSorterOption = [
  { name: 'Price (lowest)', value: 'price-low-high' },
  { name: 'Price (highest)', value: 'price-high-low' },
  { name: 'Duration (shortest)', value: 'duration-shortest' },
  { name: 'Duration (longest)', value: 'duration-longest' },
  { name: 'Departure (earliest)', value: 'departure-earliest' },
  { name: 'Departure (latest)', value: 'departure-latest' },
  { name: 'Arrival (earliest)', value: 'arrival-earliest' },
  { name: 'Arrival (latest)', value: 'arrival-latest' },
];

// responsive
export const responsive = {
  mobile: 900,
};

// list of item for header
export const headerItems = [];

const breakPointSeetings = {
  slidesToShow: 1,
  centerMode: true,
  centerPadding: '0',
  useCSS: true,
};

export const imageSliderSettings: Settings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToScroll: 1,
  dotsClass: 'slick-dots slick-dots--image',
  responsive: [
    {
      breakpoint: 400,
      settings: breakPointSeetings,
    },
    {
      breakpoint: 800,
      settings: breakPointSeetings,
    },
    {
      breakpoint: 1200,
      settings: breakPointSeetings,
    },
    {
      breakpoint: 1600,
      settings: breakPointSeetings,
    },
    {
      breakpoint: 9999,
      settings: breakPointSeetings,
    },
  ],
};
